import { render, staticRenderFns } from "./category-facet.vue?vue&type=template&id=45623bd2&scoped=true"
import script from "./category-facet.vue?vue&type=script&lang=js"
export * from "./category-facet.vue?vue&type=script&lang=js"
import style0 from "./category-facet.vue?vue&type=style&index=0&id=45623bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45623bd2",
  null
  
)

export default component.exports